import { SITE_EMAIL } from "../../shared/seo/site";

export function Privacy() {
  return (
    <main className="prose-page" id="main-content">
      <p className="eyebrow">Plain-language policy</p>
      <h1>Privacy</h1>
      <p className="lede">Nonogram Now works without an account. Your puzzle progress, streak, and best times stay in your browser.</p>
      <section>
        <span className="section-number">01</span>
        <div>
          <h2>What stays on your device</h2>
          <p>We use browser storage to remember unfinished puzzles, completed games, streaks, and best times. Clearing site data removes this information.</p>
        </div>
      </section>
      <section>
        <span className="section-number">02</span>
        <div>
          <h2>What we measure</h2>
          <p>We record limited first-party product events such as starting, completing, or sharing a puzzle, along with page performance measurements: how soon a page drew, and how much its layout moved while it did. Events use broad duration and mistake buckets and never include puzzle answers, free text, or a copied device identifier.</p>
        </div>
      </section>
      <section>
        <span className="section-number">03</span>
        <div>
          <h2>Cloudflare Web Analytics</h2>
          <p>The site also uses Cloudflare Web Analytics for anonymous page-view and performance metrics. Cloudflare states that this product does not use client-side cookies for analytics and is designed not to track individual users across sites.</p>
        </div>
      </section>
      <section>
        <span className="section-number">04</span>
        <div>
          <h2>Google Analytics</h2>
          <p>The site uses Google Analytics (Google tag G-6PSRJZFVE1) to understand how people find and use the pages. Google may set cookies such as _ga on your device and receive standard usage data, including the pages you visit. Clearing site data or blocking the script stops this. We do not sell this information.</p>
          <p>If you are in the EEA, the UK, or Switzerland, analytics and advertising storage are denied by default and are never granted, so no _ga cookie is set and you are not recognised across visits. There is no consent banner because there is nothing here to consent to.</p>
        </div>
      </section>
      <section>
        <span className="section-number">05</span>
        <div>
          <h2>No accounts or data sales</h2>
          <p>There are no user accounts or data sales in this version of Nonogram Now. Puzzle progress stays in your browser. Google Analytics is used only for traffic measurement.</p>
        </div>
      </section>
      <section>
        <span className="section-number">06</span>
        <div>
          <h2>Questions about this policy</h2>
          <p>Write to <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a> with any question about what this site collects. This policy was last updated on 5 September 2026.</p>
        </div>
      </section>
    </main>
  );
}
